<template>
    <g>
    <g class="vresistor-body">
        <text transform="matrix(1 0 0 1 90 80)" class="name st1">가변저항({{`${resist}Ω`}})</text>
        <linearGradient id="SVGID6_1_" gradientUnits="userSpaceOnUse" x1="109.8973" y1="185.9601" x2="118.4042"
            y2="185.9601">
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
            <stop offset="5.778535e-08" style="stop-color:#CECECE" />
            <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
            <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
            <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
            <stop offset="2.829547e-07" style="stop-color:#808080" />
            <stop offset="3.843944e-07" style="stop-color:#797979" />
            <stop offset="6.659737e-07" style="stop-color:#777777" />
            <stop offset="0.1529" style="stop-color:#979392" />
            <stop offset="0.332" style="stop-color:#A3A2A2" />
            <stop offset="0.4162" style="stop-color:#A0A0A1" />
            <stop offset="0.571" style="stop-color:#9D9D9E" />
            <stop offset="0.6867" style="stop-color:#949494" />
            <stop offset="0.7898" style="stop-color:#848484" />
            <stop offset="0.8854" style="stop-color:#6D6D6E" />
            <stop offset="0.9751" style="stop-color:#505051" />
            <stop offset="1" style="stop-color:#474747" />
        </linearGradient>
        <rect :id="pincode + 'PS'" @click="onClick(`${pincode}PS`)" class="pin-cover terminal snap pin-plus" x="109.9" y="182.84"
            width="8.51" height="15" />
        <linearGradient id="SVGID6_2_" gradientUnits="userSpaceOnUse" x1="138.3357" y1="185.9601" x2="146.8837"
            y2="185.9601">
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
            <stop offset="5.778535e-08" style="stop-color:#CECECE" />
            <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
            <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
            <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
            <stop offset="2.829547e-07" style="stop-color:#808080" />
            <stop offset="3.843944e-07" style="stop-color:#797979" />
            <stop offset="6.659737e-07" style="stop-color:#777777" />
            <stop offset="0.1529" style="stop-color:#979392" />
            <stop offset="0.332" style="stop-color:#A3A2A2" />
            <stop offset="0.4162" style="stop-color:#A0A0A1" />
            <stop offset="0.571" style="stop-color:#9D9D9E" />
            <stop offset="0.6867" style="stop-color:#949494" />
            <stop offset="0.7898" style="stop-color:#848484" />
            <stop offset="0.8854" style="stop-color:#6D6D6E" />
            <stop offset="0.9751" style="stop-color:#505051" />
            <stop offset="1" style="stop-color:#474747" />
        </linearGradient>
        <!--<rect x="138.34" y="182.84" class="port st1" width="8.55" height="15"/>-->
        <linearGradient id="SVGID6_3_" gradientUnits="userSpaceOnUse" x1="165.8699" y1="185.9601" x2="174.8699"
            y2="185.9601">
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
            <stop offset="5.778535e-08" style="stop-color:#CECECE" />
            <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
            <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
            <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
            <stop offset="2.829547e-07" style="stop-color:#808080" />
            <stop offset="3.843944e-07" style="stop-color:#797979" />
            <stop offset="6.659737e-07" style="stop-color:#777777" />
            <stop offset="0.1529" style="stop-color:#979392" />
            <stop offset="0.332" style="stop-color:#A3A2A2" />
            <stop offset="0.4162" style="stop-color:#A0A0A1" />
            <stop offset="0.571" style="stop-color:#9D9D9E" />
            <stop offset="0.6867" style="stop-color:#949494" />
            <stop offset="0.7898" style="stop-color:#848484" />
            <stop offset="0.8854" style="stop-color:#6D6D6E" />
            <stop offset="0.9751" style="stop-color:#505051" />
            <stop offset="1" style="stop-color:#474747" />
        </linearGradient>
        <rect :id="pincode + 'MS'" @click="onClick(`${pincode}MS`)" class="pin-cover terminal snap pin-minus" x="165.87"
            y="182.84" width="9" height="15" />
        <path class="st3" d="M181.65,185.34h-78.91c-3.13,0-5.67-2.54-5.67-5.67v-78.91c0-3.13,2.54-5.67,5.67-5.67h78.91
        c3.13,0,5.67,2.54,5.67,5.67v78.91C187.32,182.8,184.78,185.34,181.65,185.34z" />
        <g>
            <circle class="st4" cx="142.61" cy="140.22" r="31.78" />
        </g>
        <text transform="matrix(1 0 0 1 163.9799 174.4931)" class="st5 st6">MAX</text>
        <text transform="matrix(1 0 0 1 104.9662 174.4931)" class="st5 st6">MIN</text>
        <circle class="st7" cx="142.2" cy="140.22" r="22.79" />
        <polygon class="st8" points="163.16,137.67 148.61,137.67 148.61,131.84 135.21,131.84 135.21,137.67 120.91,137.67 120.91,144.58
        135.21,144.58 135.21,149.18 148.61,149.18 148.61,144.58 163.16,144.58 " />
    </g>
    <!--slider-->
    <g
        id="range-slider"
        style="transform: rotate(-90deg) translate(-130px, 65px) scale(0.5)"
        @click="initController"
    >
        <g :class="{'range-hide': !on || isSensorDataUploaded }">
            <g id="range-container">
                <path
                    d="M174,257c-8.96,0-16.25-7.29-16.25-16.25v-169c0-8.96,7.29-16.25,16.25-16.25s16.25,7.29,16.25,16.25v169
            C190.25,249.71,182.96,257,174,257z M174,59.83c-6.57,0-11.92,5.35-11.92,11.92v169c0,6.57,5.35,11.92,11.92,11.92
            s11.92-5.35,11.92-11.92v-169C185.92,65.18,180.57,59.83,174,59.83z"
                />
            </g>
            <circle
                id="slider-pin"
                :class="{ on: on && !isSensorDataUploaded }"
                cx="174"
                cy="75"
                r="26"
            />
            <polygon
                points="168.58,138.31 174,147.7 179.42,138.31 175.56,138.31 175.56,125.8 172.44,125.8 172.44,138.31 "
            />
        </g>
    </g>
    </g>
</template>

<script>
import Vue from 'vue'
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, start, end, from, to) {
  return ((val - start) / (end - start)) * (to - from) + from
}

var vm = new Vue({
  data: {
    range: {
      min: 0,
      max: 1024
    },
    draggable: []
  }
})

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Potentiometer',
  data () {
    return {
      resist: 0,
      on: false,
      socket: null,
      timemax: null
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  computed: {
    // values () {
    // //   const data = store.state.sim.data
    // //   if (data) return data.RE[Number(this.number)]
    //   // return { volt: 0, amper: 0, resist: 0 }
    // },
    isSensorDataUploaded () {
      return this.$store.state.sim.userData[this.namecode]
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    initController (e) {
      if (this.on) {
        vm.draggable = window.Draggable.create(
        `#${this.data.id} #slider-pin`,
        {
          type: 'x,y',
          bounds: `#${this.data.id} #range-container`,
          lockAxis: true,
          onClick: function (e) {
            e.stopPropagation()
          },
          onDrag: (e) => {
            const y = vm.draggable[0].y
            window.gsap.set(vm.draggable[0].target, {
              onUpdate: vm.draggable[0].update
            })

            const yv = Math.round(map(y, 6, 156, 0, 1024) * 10) / 10
            // let yv = y
            console.log(yv)

            this.controller(yv)
            // e.stopPropagation() // 시뮬레이션 시작되면 컴포넌트 움직일 수 없으니까 상관없다?
          }
        }
        )
      }
    },
    controller (val) {
      this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value: val } })
      this.resist = val
    },
    start (socket) {
      this.on = true
      this.socket = socket
      if (this.$store.state.sim.userData[this.namecode]) {
        this.socket.onmessage = ({ data }) => {
          data = JSON.parse(data)
          this.resist = Math.round(map(data.value, 6, 156, 0, 1024) * 10) / 10
        }

        this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value: this.resist } })
      } else {
        window.Draggable.get(`#${this.data.id}`).disable()
        this.initController()
      }
    },
    off () {
      this.on = false
      // this.resist = 0
      if (!this.socket) {
        window.Draggable.get(`#${this.data.id}`).enable()
      } else this.socket = null
    }
  }

}
</script>

<style lang="scss" scoped>
.selected {
  .st3, .pin-plus, .pin-minus {
      stroke-width: 4px;
      stroke: #ff6f61;
  }
}
.range-hide{fill: transparent;}

.pin-plus {
  fill: url(#SVGID6_1_);
}
.pin-minus {
  fill: url(#SVGID6_2_);
}
.st2 {
  fill: url(#SVGID6_3_);
}
/* .st0:hover,
.st1:hover,
.st2:hover {
  fill: #e60012;
} */
.st3 {
  fill: #ffffff;
  stroke: #000000;
  stroke-miterlimit: 10;
}
/* .st3:hover {
  stroke: #e60012;
  stroke-width: 3px;
} */
.st4 {
  fill: none;
  stroke: #4db0e4;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke-dasharray: 4.9903, 4.9903;
}
.st5 {
  font-family: "Calibri";
}
.st6 {
  font-size: 9px;
}
.st7 {
  fill: #1a439a;
}
.st8 {
  fill: #ffffff;
}
.vresistor-body {
  &:hover {
    cursor: pointer;
  }
}
.text {
  font-size: 30px;
  fill: #050000;
}
/* .text:hover {
  cursor: pointer;
} */
</style>
